import { SAVE_LIBRARY_CREATIVE_ERROR, SAVE_LIBRARY_CREATIVE_SUCCESS } from './actionTypes';

export const saveLibraryCreativeSuccess = creative => ({
    type: SAVE_LIBRARY_CREATIVE_SUCCESS,
    payload: creative,
});

export const saveLibraryCreativeError = (id, error) => ({
    type: SAVE_LIBRARY_CREATIVE_ERROR,
    payload: { id, error },
});
